import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-proviso-info',
  templateUrl: './proviso-info.component.html',
  styleUrls: ['./proviso-info.component.scss']
})
export class ProvisoInfoComponent implements OnInit {
    @Input() formKey: string;
    isMoreInfoOpened = false;
  constructor() { }

  ngOnInit(): void {
  }

}
